import { domLoader } from "@/loader.js";

window.desktopNavigationLoaded = false;

domLoader(function () {
  if (window.desktopNavigationLoaded) {
    return;
  }
  window.desktopNavigationLoaded = true;

  // ── Mega menu: keep aria-expanded in sync (open/close is CSS hover/focus) ──
  document.querySelectorAll(".has-mega").forEach(function (item) {
    const link = item.querySelector(".primary-nav__link");
    if (!link) return;

    const setExpanded = (state) => link.setAttribute("aria-expanded", state ? "true" : "false");

    item.addEventListener("mouseenter", () => setExpanded(true));
    item.addEventListener("mouseleave", () => setExpanded(false));
    item.addEventListener("focusin", () => setExpanded(true));
    item.addEventListener("focusout", (e) => {
      if (!item.contains(e.relatedTarget)) setExpanded(false);
    });
  });

  // ── Command search overlay ───────────────────────────────────────────────
  const modal = document.getElementById("header-search-modal");
  const trigger = document.getElementById("header-search-trigger");

  if (!modal) return;

  let lastFocused = null;

  function focusInput() {
    const input = document.getElementById("main-search-keyword");
    if (input) window.setTimeout(() => input.focus(), 60);
  }

  function openSearch() {
    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");
    trigger?.setAttribute("aria-expanded", "true");
    document.body.classList.add("header-search-open");
    lastFocused = document.activeElement;
    focusInput();
  }

  function closeSearch() {
    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");
    trigger?.setAttribute("aria-expanded", "false");
    document.body.classList.remove("header-search-open");
    if (lastFocused && typeof lastFocused.focus === "function") lastFocused.focus();
  }

  // expose so the mobile drawer can open the same overlay
  window.kingaroOpenSearch = openSearch;

  trigger?.addEventListener("click", openSearch);

  modal.querySelectorAll("[data-search-close]").forEach(function (el) {
    el.addEventListener("click", closeSearch);
  });

  modal.addEventListener("click", function (e) {
    if (e.target.closest(".cmd-search__result, .cmd-chip")) {
      closeSearch();
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && modal.classList.contains("is-open")) {
      closeSearch();
      return;
    }

    // "/" opens search when not already typing in a field
    if (
      e.key === "/" &&
      !modal.classList.contains("is-open") &&
      !/^(INPUT|TEXTAREA|SELECT)$/.test(document.activeElement?.tagName || "") &&
      !document.activeElement?.isContentEditable
    ) {
      e.preventDefault();
      openSearch();
    }
  });
});
